import React from 'react';
import FieldToggle from './FieldToggle';
import styles from '../SaleReportPage.module.scss';

const SPAN_CLASS = {
  3: styles.c3,
  4: styles.c4,
  6: styles.c6,
  8: styles.c8,
  12: styles.c12,
};

function Field({
  label,
  span = 12,
  toggle,
  toggleEnabled,
  onToggle,
  required,
  hint,
  children,
}) {
  // toggleEnabled가 명시적으로 true/false — 자동 추측 없음
  const enabled = toggle ? (toggleEnabled !== false) : true;

  const spanClass = SPAN_CLASS[span] || styles.c12;
  const fieldClasses = [styles.field, spanClass];

  if (toggle && !enabled) {
    fieldClasses.push(styles.fieldOff);
  }

  return (
    <div className={fieldClasses.join(' ')}>
      <label className={styles.fieldLabel}>
        {label}
        {required && <span className={styles.req}>*</span>}
        {hint && <span className={styles.fieldHint}>{hint}</span>}
        {toggle && (
          <FieldToggle enabled={enabled} onChange={onToggle} />
        )}
      </label>
      {children}
    </div>
  );
}

export default Field;
